import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Input, Label, FormGroup } from 'reactstrap';
// import config from "../../../../config";
import { deepClone } from '../../../../helper-methods';
import Select from 'react-dropdown-select';
import styled from 'styled-components';

const StyledOption = styled.span`
  padding: 0;
  color: #555;
  border-radius: 3px;
  margin: 3px;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  transition: all 1s ease-in;

  span {
    display: none;
    transition: all 1s ease-in;
  }

  a {
    margin: 0 5px;
  }

  :hover {
    background: #f2f2f2;

    span {
      display: inline;
      margin: 0 0 0 5px;
      color: red;
    }
  }
`;

const StyledItem = styled.div`
  padding: 10px;
  color: #555;
  border-radius: 3px;
  margin: 3px;
  cursor: pointer;

  :hover {
    background: #f2f2f2;
  }
`;
class AddDockerContainerModal extends Component {
  state = {
    machine: {
      name: '',
      description: '',
      iconId: '',
      labId: '',
      cpu: '',
      ram: '',
      ethernets: '',
      templateId: '',
      dockerImage: '',
      delay: '',
      left: 100,
      top: 100,
      count: 1,
      // Docker-specific fields
      exposedPorts: [],
      storagePools: [],
      dockerOptions: [],
      startupCommand: '',
      startupScript: ''
    },
    selectedTemplate: {},
    isDirty: {
      name: false,
      iconId: false,
      templateId: false,
      dockerImage: false,
      left: false,
      top: false,
      count: false
    },
    errors: {},
    selectedFile: null,
    selectedIcons: [],
    showAdvancedParameters: false,
    // Docker-specific UI state
    newPort: '',
    newStoragePool: { name: '', size: '', mountPath: '' },
    newDockerOption: '',
    showDockerAdvanced: false
  };

  componentDidMount() {
    const { machine } = deepClone(this.state);
    machine.labId = this.props.match.params.id;
    this.setState({ machine });
  }

  _handleOnChange = (field, value) => {
    let { machine, selectedTemplate, isDirty, selectedIcons } = deepClone(this.state);
    const { data } = deepClone(this.props);
    isDirty[field] = true;
    if (field === 'templateId') {
      if (value) {
        machine.templateId = value;
        selectedTemplate = data.vmTemplates.find((e) => e._id === value);
        console.log('selectedTemplate :>> ', selectedTemplate);
        selectedTemplate.fieldsToShow.forEach((each) => {
          machine[each.fieldName] = each.defaultValue;
        });
        machine.dockerImage = selectedTemplate?.defaultDockerImage || '';
        selectedIcons = selectedTemplate?._defaultIcon?.id
          ? this.props?.data.iconList.filter((e) => e.id === selectedTemplate?._defaultIcon?.id)
          : [];
        
        // Populate Docker-specific fields from template
        if (selectedTemplate.dockerExposedPorts) {
          machine.exposedPorts = [...selectedTemplate.dockerExposedPorts];
        }
        if (selectedTemplate.dockerStoragePools) {
          machine.storagePools = [...selectedTemplate.dockerStoragePools];
        }
        if (selectedTemplate.dockerOptions) {
          machine.dockerOptions = [...selectedTemplate.dockerOptions];
        }
        if (selectedTemplate.startupCommand) {
          machine.startupCommand = selectedTemplate.startupCommand;
        }
        if (selectedTemplate.startupScript) {
          machine.startupScript = selectedTemplate.startupScript;
        }
      } else {
        machine.templateId = value;
        selectedTemplate = {};
      }
      this.setState({ machine, selectedTemplate, isDirty, selectedIcons }, () => {
        this._validateFields();
      });
    } else {
      machine[field] = value;
      this.setState({ machine, isDirty }, () => {
        this._validateFields();
      });
    }
  };

  _validateFields = () => {
    const { machine, isDirty, errors, selectedIcons } = this.state;
    Object.keys(machine).forEach((each) => {
      if (each === 'name' && isDirty.name) {
        if (!machine.name.trim().length) {
          errors[each] = '*Required';
        } else {
          delete errors[each];
          isDirty.name = false;
        }
      } else if (each === 'templateId' && isDirty.templateId) {
        if (!machine.templateId.trim().length) {
          errors[each] = '*Select a template';
        } else {
          delete errors[each];
          isDirty.templateId = false;
        }
      } else if (each === 'dockerImage' && isDirty.dockerImage) {
        if (!machine.dockerImage.trim().length) {
          errors[each] = '*Selct a vmImage';
        } else {
          delete errors[each];
          isDirty.dockerImage = false;
        }
      } else if (each === 'iconId' && isDirty.iconId) {
        if (!selectedIcons.length) {
          errors[each] = '*Selct an Icon';
        } else {
          delete errors[each];
          isDirty.iconId = false;
        }
      } else if (each === 'left' && isDirty.left) {
        if (machine.left.length && isNaN(machine.left)) {
          errors[each] = 'Should be Number';
        } else {
          delete errors[each];
          isDirty.left = false;
        }
      } else if (each === 'top' && isDirty.top) {
        if (machine.top.length && isNaN(machine.top)) {
          errors[each] = 'Should be Number';
        } else {
          delete errors[each];
          isDirty.top = false;
        }
      } else if (each === 'count' && isDirty.count) {
        if (!machine.count.toString().length) {
          errors[each] = '*Required';
        } else if (machine.count.length && isNaN(machine.count)) {
          errors[each] = 'Should be Number';
        } else if (machine.count.length && !isNaN(machine.count) && (machine.count <= 0 || machine.count > 10)) {
          errors[each] = 'Number should be between 1 to 10';
        } else {
          delete errors[each];
          isDirty.count = false;
        }
      }
    });
    this.setState({ errors });
    return Object.keys(errors).length ? errors : null;
  };

  _customOptionRenderer = ({ item, props, state, methods }) => {
    return (
      <StyledOption>
        <img src={item.url} width={30} alt={item.name} />
        &nbsp;
        {item.name}
        <span
          onClick={() => {
            methods.removeItem(null, item);
            this.setState({ selectedIcons: [] }, () => {
              this._validateFields();
            });
          }}>
          &times;
        </span>
      </StyledOption>
    );
  };

  _customItemRenderer = ({ item, itemIndex, props, state, methods }) => {
    const { selectedIcons } = deepClone(this.state);

    return (
      <StyledItem>
        <div
          onClick={() => {
            console.log('selectedIcons :>> ', item);
            methods.addItem(item);
            const { isDirty } = deepClone(this.state);
            isDirty.iconId = true;
            const isAlreadyPresent = selectedIcons.length && selectedIcons[0].id === item.id;
            this.setState(
              {
                selectedIcons: isAlreadyPresent ? [] : [item],
                selectedFile: null,
                previewImg: null,
                isDirty
              },
              () => {
                this._validateFields();
              }
            );
          }}>
          {item.isFirstDefaultIcon && <div className='custom-select-section'>System Icons</div>}
          {item.isFirstIcon && <div className='custom-select-section'>Custom Icons</div>}
          <img src={item.url} width={30} alt={item.name} /> &nbsp;
          {item.name}
        </div>
      </StyledItem>
    );
  };

  _inputType = (field) => {
    switch (field.dataType) {
      case 'String':
        return 'text';
      case 'Number':
        return 'number';
      case 'Boolean':
        return 'checkbox';
      default:
        return 'text';
    }
  };

  _handleOnSubmit = () => {
    const { machine, selectedTemplate, selectedIcons } = deepClone(this.state);
    let isDirty = {
      name: true,
      iconId: true,
      templateId: true,
      dockerImage: true,
      left: true,
      top: true,
      count: true
    };
    this.setState({ isDirty }, () => {
      let errors = this._validateFields();
      if (!errors) {
        let dataToSend = {
          name: machine.name,
          description: machine.description,
          iconId: selectedIcons[0].id,
          iconURL: selectedIcons[0].url,
          labId: machine.labId,
          cpu: selectedTemplate.fieldsToShow.find((e) => e.fieldName === 'vcpus') ? Number(machine.vcpus) : undefined,
          ram: selectedTemplate.fieldsToShow.find((e) => e.fieldName === 'ram') ? Number(machine.ram) : undefined,
          ethernets: selectedTemplate.fieldsToShow.find((e) => e.fieldName === 'ethernets')
            ? Number(machine.ethernets)
            : undefined,
          delay: selectedTemplate.fieldsToShow.find((e) => e.fieldName === 'delay') ? Number(machine.delay) : undefined,
          templateId: machine.templateId,
          dockerImage: machine.dockerImage,
          dataFromTemplate: {},
          position: {
            x: machine.left ? Number(machine.left) : 100,
            y: machine.top ? Number(machine.top) : 100
          },
          count: machine.count,
          // Docker-specific fields
          exposedPorts: machine.exposedPorts,
          storagePools: machine.storagePools,
          dockerOptions: machine.dockerOptions,
          startupCommand: machine.startupCommand,
          startupScript: machine.startupScript
        };
        selectedTemplate.fieldsToShow.forEach((each) => {
          dataToSend.dataFromTemplate[each.fieldName] = machine[each.fieldName];
        });
        console.log('dataToSend :>> ', dataToSend);
        this.props.toggle('save', dataToSend);
      }
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      let state = {
        machine: {
          name: '',
          description: '',
          iconId: '',
          labId: this.props.match.params.id,
          cpu: '',
          ram: '',
          ethernets: '',
          templateId: '',
          dockerImage: '',
          delay: '',
          left: 100,
          top: 100,
          count: 1,
          // Docker-specific fields
          exposedPorts: [],
          storagePools: [],
          dockerOptions: [],
          startupCommand: '',
          startupScript: ''
        },
        selectedTemplate: {},
        isDirty: {
          name: false,
          iconId: false,
          templateId: false,
          dockerImage: false,
          left: false,
          top: false,
          count: false
        },
        errors: {},
        selectedFile: null,
        selectedIcons: [],
        showAdvancedParameters: false,
        // Docker-specific UI state
        newPort: '',
        newStoragePool: { name: '', size: '', mountPath: '' },
        newDockerOption: '',
        showDockerAdvanced: false
      };
      this.setState(state);
    }
  }

  _checkFieldCanbeShown = (each) => {
    const { showAdvancedParameters } = deepClone(this.state);
    const fieldKeys = ['ethernets', 'vcpus', 'ram'];
    if (fieldKeys.includes(each.fieldName)) {
      return true; // Always show
    } else {
      return showAdvancedParameters; // Show if 'Show Advanced Parameters' checkbox is checked
    }
  };

  _onAdvParamsToggle = () => {
    const { showAdvancedParameters } = deepClone(this.state);
    this.setState({ showAdvancedParameters: !showAdvancedParameters });
  };

  _onDockerAdvToggle = () => {
    const { showDockerAdvanced } = deepClone(this.state);
    this.setState({ showDockerAdvanced: !showDockerAdvanced });
  };

  _addPort = () => {
    const { machine, newPort } = deepClone(this.state);
    if (newPort.trim()) {
      machine.exposedPorts = [...machine.exposedPorts, newPort.trim()];
      this.setState({ machine, newPort: '' });
    }
  };

  _removePort = (index) => {
    const { machine } = deepClone(this.state);
    machine.exposedPorts = machine.exposedPorts.filter((_, i) => i !== index);
    this.setState({ machine });
  };

  _addStoragePool = () => {
    const { machine, newStoragePool } = deepClone(this.state);
    if (newStoragePool.name && newStoragePool.size && newStoragePool.mountPath) {
      machine.storagePools = [...machine.storagePools, { ...newStoragePool }];
      this.setState({
        machine,
        newStoragePool: { name: '', size: '', mountPath: '' }
      });
    }
  };

  _removeStoragePool = (index) => {
    const { machine } = deepClone(this.state);
    machine.storagePools = machine.storagePools.filter((_, i) => i !== index);
    this.setState({ machine });
  };

  _addDockerOption = () => {
    const { machine, newDockerOption } = deepClone(this.state);
    if (newDockerOption.trim()) {
      machine.dockerOptions = [...machine.dockerOptions, newDockerOption.trim()];
      this.setState({ machine, newDockerOption: '' });
    }
  };

  _removeDockerOption = (index) => {
    const { machine } = deepClone(this.state);
    machine.dockerOptions = machine.dockerOptions.filter((_, i) => i !== index);
    this.setState({ machine });
  };

  _handleStoragePoolChange = (field, value) => {
    const { newStoragePool } = deepClone(this.state);
    newStoragePool[field] = value;
    this.setState({ newStoragePool });
  };

  render() {
    const { machine, errors, selectedTemplate, showAdvancedParameters, showDockerAdvanced, newPort, newStoragePool, newDockerOption } = deepClone(this.state);
    const { data } = deepClone(this.props);
    return (
      <Modal size={'lg'} isOpen={this.props.isOpen} toggle={() => this.props.toggle('close')}>
        <ModalHeader toggle={() => this.props.toggle('close')}>
          <p className='text-white'>Add New Docker Container</p>
        </ModalHeader>
        <ModalBody style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }} className='innerForm'>
          <FormGroup>
            <Label>Template</Label>
            <Input
              type='select'
              placeholder='Select Template'
              value={machine.templateId}
              onChange={(e) => this._handleOnChange('templateId', e.target.value)}>
              <option value=''>Select Template</option>
              {React.Children.toArray(data?.vmTemplates?.map((each) => <option value={each._id}>{each.name}</option>))}
            </Input>
            {errors && <div className='validation-error'>{errors.templateId}</div>}
          </FormGroup>
          {machine.templateId && (
            <div>
              <FormGroup>
                <Label>Number of Dockers to add</Label>
                <Input
                  type='number'
                  placeholder='Enter'
                  min={1}
                  max={10}
                  value={machine.count}
                  onChange={(e) => this._handleOnChange('count', e.target.value)}
                />
                {errors && <div className='validation-error'>{errors.count}</div>}
              </FormGroup>
              <FormGroup>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ width: '45%' }}>
                    <Label>Image</Label>
                    <Input
                      type='select'
                      placeholder='Select Image'
                      value={machine.dockerImage}
                      onChange={(e) => this._handleOnChange('dockerImage', e.target.value)}>
                      <option value=''>Select Image</option>
                      {React.Children.toArray(
                        selectedTemplate.dockerImagesToShow.map((each) => <option value={each}>{each}</option>)
                      )}
                    </Input>
                    {errors && <div className='validation-error'>{errors.dockerImage}</div>}
                  </div>
                  <div style={{ width: '45%' }}>
                    <Label>Icon</Label>
                    <Select
                      placeholder='Select Icon'
                      multi={true}
                      keepOpen={false}
                      searchable={false}
                      optionRenderer={this._customOptionRenderer}
                      itemRenderer={this._customItemRenderer}
                      onChange={(value) => this._handleOnChange('iconId', value)}
                      values={this.state.selectedIcons}
                      options={data?.iconList}
                      labelField={'name'}
                      valueField={'id'}
                      closeOnSelect={true}
                    />
                    {errors && <div className='validation-error'>{errors.iconId}</div>}
                  </div>
                </div>
              </FormGroup>
              <FormGroup>
                <Label>Name</Label>
                <Input
                  type='text'
                  rows='3'
                  placeholder='Enter name'
                  value={machine.name}
                  onChange={(e) => this._handleOnChange('name', e.target.value)}
                />
                {errors && <div className='validation-error'>{errors.name}</div>}
              </FormGroup>
              <FormGroup>
                <Label>Description</Label>
                <Input
                  type='textarea'
                  rows='3'
                  placeholder='Enter description'
                  value={machine.description}
                  onChange={(e) => this._handleOnChange('description', e.target.value)}
                />
              </FormGroup>
              <FormGroup className='adv-check-wrap'>
                <div className='mr-2 cussor-pointer' onClick={this._onAdvParamsToggle}>
                  Show Advanced Parameters
                </div>
                <div className='checkbox-wrap'>
                  <input type='checkbox' checked={showAdvancedParameters} onChange={() => this._onAdvParamsToggle()} />
                </div>
              </FormGroup>
              <FormGroup>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between'
                  }}>
                  {React.Children.toArray(
                    selectedTemplate?.fieldsToShow.map((each) => {
                      return this._checkFieldCanbeShown(each) ? (
                        <div style={{ margin: '0 10px 10px 0' }}>
                          <Label>{each.label}</Label>
                          <input
                            className={each.dataType !== 'Boolean' ? 'form-control' : 'boolean-input'}
                            type={this._inputType(each)}
                            rows='3'
                            placeholder={`Enter ${each.fieldName}`}
                            disabled={!each.isEditable}
                            value={machine[each.fieldName]}
                            checked={each.defaultValue}
                            onChange={(e) => this._handleOnChange(each.fieldName, e.target.value)}
                          />
                          {errors && <div className='validation-error'>{errors[each.fieldName]}</div>}
                        </div>
                      ) : (
                        <></>
                      );
                    })
                  )}
                </div>
              </FormGroup>
              <FormGroup>
                <Label>Position</Label>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ width: '45%' }}>
                    <Label>Left</Label>
                    <Input
                      type='text'
                      placeholder='Enter Left'
                      value={machine.left}
                      onChange={(e) => this._handleOnChange('left', e.target.value)}
                    />
                    {errors && <div className='validation-error'>{errors.left}</div>}
                  </div>
                  <div style={{ width: '45%' }}>
                    <Label>Top</Label>
                    <Input
                      type='text'
                      placeholder='Enter Top'
                      value={machine.top}
                      onChange={(e) => this._handleOnChange('top', e.target.value)}
                    />
                    {errors && <div className='validation-error'>{errors.top}</div>}
                  </div>
                </div>
              </FormGroup>
            </div>
          )}
          
          {/* Docker Advanced Parameters */}
          {machine.templateId && (
            <div>
              <FormGroup className='adv-check-wrap'>
                <div className='mr-2 cussor-pointer' onClick={this._onDockerAdvToggle}>
                  Show Docker Advanced Parameters
                </div>
                <div className='checkbox-wrap'>
                  <input type='checkbox' checked={showDockerAdvanced} onChange={() => this._onDockerAdvToggle()} />
                </div>
              </FormGroup>
              
              {showDockerAdvanced && (
                <div>
                  {/* Exposed Ports */}
                  <FormGroup>
                    <Label>Exposed Ports</Label>
                    <div style={{ display: 'flex', marginBottom: '10px' }}>
                      <Input
                        type='text'
                        placeholder='e.g., 8080:80 or 3000'
                        value={newPort}
                        onChange={(e) => this.setState({ newPort: e.target.value })}
                        style={{ marginRight: '10px' }}
                      />
                      <Button color='primary' onClick={this._addPort}>
                        Add Port
                      </Button>
                    </div>
                    {machine.exposedPorts.length > 0 && (
                      <div>
                        <Label>Configured Ports:</Label>
                        {machine.exposedPorts.map((port, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <span style={{ flex: 1 }}>{port}</span>
                            <Button color='danger' size='sm' onClick={() => this._removePort(index)}>
                              Remove
                            </Button>
                          </div>
                        ))}
                      </div>
                    )}
                  </FormGroup>

                  {/* Storage Pools */}
                  <FormGroup>
                    <Label>Storage Pools</Label>
                    <div style={{ border: '1px solid #ddd', padding: '10px', borderRadius: '4px', marginBottom: '10px' }}>
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                        <Input
                          type='text'
                          placeholder='Pool Name'
                          value={newStoragePool.name}
                          onChange={(e) => this._handleStoragePoolChange('name', e.target.value)}
                        />
                        <Input
                          type='text'
                          placeholder='Size (e.g., 10GB)'
                          value={newStoragePool.size}
                          onChange={(e) => this._handleStoragePoolChange('size', e.target.value)}
                        />
                        <Input
                          type='text'
                          placeholder='Mount Path'
                          value={newStoragePool.mountPath}
                          onChange={(e) => this._handleStoragePoolChange('mountPath', e.target.value)}
                        />
                      </div>
                      <Button color='primary' onClick={this._addStoragePool}>
                        Add Storage Pool
                      </Button>
                    </div>
                    {machine.storagePools.length > 0 && (
                      <div>
                        <Label>Configured Storage Pools:</Label>
                        {machine.storagePools.map((pool, index) => (
                          <div key={index} style={{ border: '1px solid #eee', padding: '8px', marginBottom: '5px', borderRadius: '4px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div>
                                <strong>{pool.name}</strong> - {pool.size} - {pool.mountPath}
                              </div>
                              <Button color='danger' size='sm' onClick={() => this._removeStoragePool(index)}>
                                Remove
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </FormGroup>

                  {/* Docker Options */}
                  <FormGroup>
                    <Label>Docker Options</Label>
                    <div style={{ display: 'flex', marginBottom: '10px' }}>
                      <Input
                        type='text'
                        placeholder='e.g., --env VAR=value or --privileged'
                        value={newDockerOption}
                        onChange={(e) => this.setState({ newDockerOption: e.target.value })}
                        style={{ marginRight: '10px' }}
                      />
                      <Button color='primary' onClick={this._addDockerOption}>
                        Add Option
                      </Button>
                    </div>
                    {machine.dockerOptions.length > 0 && (
                      <div>
                        <Label>Configured Options:</Label>
                        {machine.dockerOptions.map((option, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <span style={{ flex: 1 }}>{option}</span>
                            <Button color='danger' size='sm' onClick={() => this._removeDockerOption(index)}>
                              Remove
                            </Button>
                          </div>
                        ))}
                      </div>
                    )}
                  </FormGroup>

                  {/* Startup Command */}
                  <FormGroup>
                    <Label>Startup Command</Label>
                    <Input
                      type='textarea'
                      rows='2'
                      placeholder='Command to run when container starts (e.g., /bin/bash -c "echo hello")'
                      value={machine.startupCommand}
                      onChange={(e) => this._handleOnChange('startupCommand', e.target.value)}
                    />
                  </FormGroup>

                  {/* Startup Script */}
                  <FormGroup>
                    <Label>Startup Script</Label>
                    <Input
                      type='textarea'
                      rows='3'
                      placeholder='Shell script to execute on container startup'
                      value={machine.startupScript}
                      onChange={(e) => this._handleOnChange('startupScript', e.target.value)}
                    />
                  </FormGroup>
                </div>
              )}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className='modalBtnCancel' onClick={() => this.props.toggle('close')}>
            Cancel
          </Button>
          <Button className='modalBtnSave' onClick={(e) => this._handleOnSubmit(e)}>
            Create
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AddDockerContainerModal;
